import { FC } from "react";

const Vision: FC = () => {
	return (
		<div
			className="w-full min-h-dvh snap-start pt-[168px] pb-[64px] md:pb-0 px-[32px] md:px-0 bg-cover bg-center bg-no-repeat flex flex-col gap-[48px] md:gap-[92px] items-center"
			style={{ backgroundImage: "url(/landingpage/orange-bg.png)" }}
		>
			<h1 className="font-satoshi font-bold text-[24px] leading-[28px] md:text-h2 md:leading-[56px] text-center text-white w-full">
				The future we’re building
			</h1>

			<div className="flex flex-col md:flex-row gap-6 md:gap-8">
				<div className="flex flex-col gap-6 bg-[#00000085] py-8 px-6 max-w-[620px] md:max-w-[337px]">
					<p className="font-satoshi font-medium text-[20px] leading-[32px] md:text-2xl text-white w-full">
						Learning will start with companions.
					</p>
					<p className="font-satoshi font-light text-base md:text-[20px] md:leading-[32px] text-[#F4F4F4]">
						Future of learning will not begin with search engines, ads,
						generalised courses or reactive chat tools. It will begin with
						companions that understand you.
					</p>
				</div>
				<div className="flex flex-col gap-6 bg-[#00000085] py-8 px-6 max-w-[620px] md:max-w-[337px]">
					<p className="font-satoshi font-medium text-[20px] leading-[32px] md:text-2xl text-white w-full">
						Democratise personalised learning.
					</p>
					<p className="font-satoshi font-light text-base md:text-[20px] md:leading-[32px] text-[#F4F4F4]">
						Personalized learning, once limited, is now accessible to everyone -
						powered by AI that adapts to your mind, progress, and learning
						journey.
					</p>
				</div>
				<div className="flex flex-col gap-6 bg-[#00000085] py-8 px-6 max-w-[620px] md:max-w-[337px]">
					<p className="font-satoshi font-medium text-[20px] leading-[32px] md:text-2xl text-white w-full">
						AI for human intelligence.
					</p>
					<p className="font-satoshi font-light text-base md:text-[20px] md:leading-[32px] text-[#F4F4F4]">
						Use AI to strengthen human intelligence - helping people think
						better, learn deeper, and grow continuously.
					</p>
				</div>
			</div>
		</div>
	);
};

export default Vision;
